import { fetchApi } from '@/helpers/fetchApi.js'

export default {
  state: {
    products: [],
    products_loading: false,
  },
  getters: {
    five_products: (state) =>
      state.products.filter(
        ({ name }) => !name.includes('Sustainable') && !name.includes('durables'),
      ),
    products: (state) => state.products,
  },
  mutations: {
    setProducts(state, products) {
      state.products = products.map((product) => {
        product.business_units = product.business_units.map((unit) => ({
          ...unit,
          label: unit.name,
          link: unit.website,
        }))
        return product
      })
    },
    setProductsLoading(state, value) {
      state.products_loading = value
    },
  },
  actions: {
    async fetchProducts({ state, commit }) {
      if (state.products_loading) return

      commit('setProductsLoading', true)

      try {
        const products = await fetchApi('products')

        commit('setProducts', products)
      } finally {
        commit('setProductsLoading', false)
      }
    },
    async loadProducts({ state, dispatch }) {
      if (!state.products.length) {
        await dispatch('fetchProducts')
      }
    },
    async emptyProducts({ commit }) {
      commit('setProducts', [])
    },
  },
}
